'use strict';
const defaultTheme = require('@mindmup/mapjs-core/src/themes/theme-default'),
	createSVGDOM = require('./create-svg-dom'),
	pathElement = createSVGDOM('path');
module.exports = function calcLabelCenterPoint(connection, fromBox, toBox, d) {
	const labelTheme = (connection.theme && connection.theme.label) || defaultTheme.connector.default.label,
		labelPosition = labelTheme.position || {},
		lineWidthAttr = connection.theme && connection.theme.line && connection.theme.line.width,
		lineWidth = (Number.isFinite(lineWidthAttr) && lineWidthAttr) || 0;

	pathElement.setAttribute('d', d);
	if (Number.isFinite(labelPosition.aboveEnd)) {
		const middleToBox = toBox.left + (toBox.width / 2) - connection.position.left,
			middleFromBox = fromBox.left + (fromBox.width / 2) - connection.position.left,
			multiplier = labelPosition.ratio || 1;
		return {
			x: Math.round(middleFromBox + multiplier * (middleToBox - middleFromBox)),
			y: toBox.top - connection.position.top - labelPosition.aboveEnd - lineWidth
		};
	} else if (labelPosition.belowEnd) {
		const middleToBox = toBox.left + (toBox.width / 2) - connection.position.left,
			middleFromBox = fromBox.left + (fromBox.width / 2) - connection.position.left,
			multiplier = labelPosition.ratio || 1;
		return {
			x: Math.round(middleFromBox + multiplier * (middleToBox - middleFromBox)),
			y: toBox.top + toBox.height - connection.position.top + labelPosition.belowEnd - lineWidth
		};
	} else if (Number.isFinite(labelPosition.aboveEndLeft)) {
		return {
			x: (fromBox.left - connection.position.left),
			y: toBox.top - connection.position.top - labelPosition.aboveEndLeft
		};

	} else if (labelPosition.ratio) {
		return pathElement.getPointAtLength(pathElement.getTotalLength() * labelTheme.position.ratio);
	}

	return pathElement.getPointAtLength(pathElement.getTotalLength() * 0.5);

};

